import React from "react";
import BreadCrumb from "common/breadcrumb";
import DefaultWithout from "./default-without";
import EvenOdd from "./even-odd";
import HoverAbleStripedRows from "./hover-able-striped-rows";
import BorderBordered from "./border-bordered";
import ColorsTable from "./colors-table";
import CustomCardTable from "./custom-card-table";

const BasicTable = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Basic Table" pageTitle="Tables" />

                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-2">
                    <DefaultWithout />
                    <EvenOdd />
                    <HoverAbleStripedRows />
                    <BorderBordered />
                    <ColorsTable />
                    <CustomCardTable />
                </div>
            </div>
        </React.Fragment>
    );
}

export default BasicTable;